var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_214_1194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 46C43.9411 46 52 37.9411 52 28C52 18.0589 43.9411 10 34 10C24.0589 10 16 18.0589 16 28C16 37.9411 24.0589 46 34 46Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0974 28.3378V27.0543H34.4678V24.4247H33.1843V27.0543H30.5548V28.3378H33.1843V30.9674H34.4678V28.3378H37.0974ZM38.3809 21.8265C38.7357 21.8265 39.0435 21.9569 39.3043 22.2178C39.5652 22.4787 39.6957 22.7865 39.6957 23.1413V32.2508C39.6957 32.6056 39.5652 32.9134 39.3043 33.1743C39.0435 33.4352 38.7357 33.5656 38.3809 33.5656H29.2713C28.9061 33.5656 28.593 33.4352 28.3322 33.1743C28.0817 32.9134 27.9565 32.6056 27.9565 32.2508V23.1413C27.9565 22.7865 28.0817 22.4787 28.3322 22.2178C28.593 21.9569 28.9061 21.8265 29.2713 21.8265H38.3809Z",
    fill: "#0D0D0D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_214_1194",
    x: 0.347824,
    y: 0.608694,
    width: 67.3044,
    height: 67.3044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.26087
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.82609
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.894118 0 0 0 0 0.894118 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_214_1194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_214_1194",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCreate);
export default __webpack_public_path__ + "static/media/dark-create.8c897fc732f8061cefa62d4c3a9b4ee9.svg";
export { ForwardRef as ReactComponent };